module.exports = __webpack_public_path__ + "img/yqjf.aac26780.png";